import type { ReactNode } from "react";
import { DialogTitle } from "@headlessui/react";
import { PlanDialog } from "~/components/plans/components/PlanDialog";

export function CheckoutStatusDialog({
  title = "Sit tight",
  summary = "We’re checking your booking. This should only take a moment.",
  spinning = true,
  onClose,
  children,
}: {
  title?: string;
  summary?: string;
  spinning?: boolean;
  onClose?: () => void;
  children?: ReactNode;
}) {
  return (
    <PlanDialog includeLogo={false} onClose={onClose}>
      <div className="flex flex-col items-center justify-center mt-3 sm:mt-5 gap-4">
        {spinning && <div className="w-10 h-10 border-4 border-butter-green/30 border-t-butter-green rounded-full animate-spin" />}
        <DialogTitle as="h3" className="font-serif text-butter-green text-xl text-center">
          {title}
        </DialogTitle>
        <p role="status" className="font-sans text-butter-green text-center">
          {summary}
        </p>
        {children}
      </div>
    </PlanDialog>
  );
}
